import { defineStore } from 'pinia'
import { apiService } from '@/services/api'

export const useJoinStore = defineStore('join', {
  state: () => ({
    formData: {
      corporateNumber: '',
      companyName: '',
      companyNameKana: '',
      lastName: '',
      firstName: '',
      lastKana: '',
      firstKana: '',
      email: '',
      password: '',
      passwordConfirm: '',
      postalCode: ['', ''],
      prefecture: '',
      prefectureKana: '',
      address1: '',
      address1Kana: '',
      address2: '',
      address2Kana: '',
      phone: ['', '', ''],
      agreedTermsRevision: null,
    },
    isAddressFetching: false,
    lastFetchedPostalCode: '',
  }),

  actions: {
    // フォームデータの初期化
    initFormData() {
      this.formData = {
        corporateNumber: '',
        companyName: '',
        companyNameKana: '',
        lastName: '',
        firstName: '',
        lastKana: '',
        firstKana: '',
        email: '',
        password: '',
        passwordConfirm: '',
        postalCode: ['', ''],
        prefecture: '',
        prefectureKana: '',
        address1: '',
        address1Kana: '',
        address2: '',
        address2Kana: '',
        phone: ['', '', ''],
        agreedTermsRevision: null,
      }
    },

    // 利用規約同意トグル
    toggleTermsAgreement(currentRevision) {
      if (this.isAgreeToTerms) {
        // すでに同意している場合は解除
        this.formData.agreedTermsRevision = null
      } else {
        // 同意していない場合は同意する
        this.formData.agreedTermsRevision = currentRevision
      }
    },

    // 住所設定（AddressStoreからのデータを受け取る場合）
    setAddress(address) {
      if (!address) return
      this.formData.prefecture = address.prefecture
      this.formData.address1 = address.address1
      this.formData.prefectureKana = address.prefectureKana
      // 半角数字を全角数字に変換
      if (address.address1Kana) {
        this.formData.address1Kana = address.address1Kana.replace(/[0-9]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
        })
      } else {
        this.formData.address1Kana = address.address1Kana
      }
    },

    // 登録API呼び出し
    async join() {
      try {
        const response = await apiService.post('/api/join', this.formData)
        return true
      } catch (error) {
        return false
      }
    },

    // パスワードが一致しているか
    isPasswordMatch() {
      return this.formData.password === this.formData.passwordConfirm
    },
  },

  getters: {
    // フォームのバリデーション
    isFormValid: state => {
      return state.formData.corporateNumber && state.formData.companyName && state.formData.lastName && state.formData.firstName && state.formData.email && state.formData.password && state.formData.passwordConfirm && state.formData.postalCode[0] && state.formData.postalCode[1] && state.formData.prefecture && state.formData.address1 && state.formData.phone[0] && state.formData.phone[1] && state.formData.phone[2] && state.isAgreeToTerms
    },

    // 利用規約に同意しているか
    isAgreeToTerms: state => {
      return !!state.formData.agreedTermsRevision
    },

    // 郵便番号が両方入力されているか
    isPostalCodeFilled: state => {
      return state.formData.postalCode[0].length === 3 && state.formData.postalCode[1].length === 4
    },

    // 郵便番号をハイフン付きにして返す
    postalCodeWithHyphen: state => {
      return state.formData.postalCode.join('-')
    },
  },
})
